// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"892":"8910b9a0","957":"8910b9a0"}[chunkId] + ".chunk.css";
};